<template>
  <div style="background-color: #fff">
    <Header :isHome="false"></Header>
    <div
      class="container"
      style="padding: 7rem 0 3rem"
      :style="{ paddingTop: isMobile ? '5rem' : '7rem' }"
    >
      <div class="">
        <!-- 顶部路由 -->
        <div>
          <div
            class="row main-box"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-left: 15px;
              padding-right: 15px;
              flex-direction: row;
            "
          >
            <div style="font-size: 1rem; color: #000; font-weight: 500">
              <span
                class="hover-light"
                style="cursor: pointer; margin-right: 0.5rem"
                @click="tohome()"
                >Home</span
              >>
              <span style="margin-left: 0.5rem"
                >Apply to Service Providers</span
              >
            </div>
          </div>
        </div>

        <div>
          <div class="r-title" style="margin-top: 2rem">
            <img
              src="../../assets/imgs/news/news-title-bg.png"
              class="r-title-bg"
            />
            <span style="z-index: 1; position: relative"
              >Service Providers information</span
            >
          </div>

          <div
            style="
              border: 1px solid #ddd7d7;
              border-radius: 0.5rem;
              margin-bottom: 1rem;
            "
            class="box-main"
          >
            <div class="row" style="margin-bottom: 1rem">
              <!-- 供应商背景图片 -->
              <div class="w-50" style="">
                <div
                  style="
                    margin-bottom: 1rem;
                    display: flex;
                    align-items: center;
                    font-size: 1.2rem;
                    font-weight: bold;
                  "
                >
                  <span style="color: #fb2121">*</span>Supplier cover image
                </div>
                <div
                  :style="{ backgroundImage: 'url(' + coverimage + ')' }"
                  style="
                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: top center;
                    border: 1px solid #bfbfbf;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 25rem;
                    height: 10rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    margin-bottom: 1rem;
                    color: #888888;
                  "
                  @click="clickcoverimage"
                  class="mw-100"
                >
                  <div
                    v-if="!coverimage"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    "
                  >
                    <div style="margin-bottom: 0.5rem">
                      <img
                        src="../../assets/imgs/upload-img.svg"
                        style="width: 2rem; height: 2rem"
                      />
                    </div>
                    upload picture
                  </div>
                </div>

                <form action="" enctype="multipart/form-data">
                  <input
                    ref="coverimage"
                    type="file"
                    multiple="multiple"
                    accept="image/*"
                    @change="getcoverimage"
                    id="coverimage"
                    style="display: none"
                  />
                </form>
                <div
                  style="font-size: 0.8rem; color: #888888; width: 25rem"
                  class="mw-100"
                >
                  It is recommended to use high-definition large pictures to
                  reflect the company’s image (such as office buildings, image
                  walls) size 1200*1000 proportional size
                </div>
              </div>

              <!-- 供应商logo -->
              <div class="w-50" style="">
                <div
                  style="
                    margin-bottom: 1rem;
                    display: flex;
                    align-items: center;
                    font-size: 1.2rem;
                    font-weight: bold;
                  "
                >
                  <span style="color: #fb2121">*</span>Logo
                </div>
                <div
                  :style="{ backgroundImage: 'url(' + logo + ')' }"
                  style="
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: top center;
                    border: 1px solid #bfbfbf;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 10rem;
                    height: 10rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    margin-bottom: 1rem;
                    color: #888888;
                  "
                  @click="clicklogo"
                >
                  <div
                    v-if="!logo"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                    "
                  >
                    <div style="margin-bottom: 0.5rem">
                      <img
                        src="../../assets/imgs/upload-img.svg"
                        style="width: 2rem; height: 2rem"
                      />
                    </div>
                    upload picture
                  </div>
                </div>
                <form action="" enctype="multipart/form-data">
                  <input
                    ref="logo"
                    type="file"
                    multiple="multiple"
                    accept="image/*"
                    @change="getlogo"
                    id="logo"
                    style="display: none"
                  />
                </form>
                <div
                  style="font-size: 0.8rem; color: #888888; width: 25rem"
                  class="mw-100"
                >
                  High-definition large image, white background color jpg or PNG
                  format, recommended size 1:1
                </div>
              </div>
            </div>

            <!-- 行业 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                <span style="color: #fb2121">*</span>Industry
              </div>
              <div>
                <div style="position: relative" class="publish-input">
                  <div
                    style="display: flex; align-items: center; cursor: pointer"
                    @click="tagbox = !tagbox"
                  >
                    <span v-if="!tag" style="color: #ccc">please choose</span
                    >{{ tag }}
                  </div>
                  <div style="" class="sel-box" v-show="tagbox">
                    <div
                      v-for="(item, index) in tagdata"
                      :key="index"
                      class="sel-box-list"
                      @click="changetag(item)"
                    >
                      <span style="flex: 1">{{ item.en }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 供应商名称 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                <span style="color: #fb2121">*</span>Supplier name
              </div>
              <div>
                <div style="position: relative" class="publish-input">
                  <input
                    type="text"
                    v-model="name"
                    style="
                      border: none;
                      background-color: transparent;
                      width: 100%;
                    "
                  />
                </div>
              </div>
            </div>

            <!-- 简要介绍 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                <span style="color: #fb2121">*</span>Brief introduction
              </div>
              <div>
                <textarea
                  cols="30"
                  rows="10"
                  style="width: 100%; height: 10rem; cursor: initial"
                  class="publish-input"
                  v-model="content1"
                ></textarea>
              </div>
            </div>

            <!-- 企业认证 -->
            <div class="row" style="position: relative; flex-direction: column">
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                <!-- <span style="color: #FB2121;">*</span> -->
                Enterprise Certification
              </div>
              <!-- <input type="text" class="login-input" placeholder="Choose tags" v-model="tags" style="width: 21rem;"> -->
              <div
                class="publish-input"
                style="
                  min-height: 2.5rem;
                  display: flex;
                  align-items: center;
                  cursor: pointer;
                "
                @click="cbox = !cbox"
              >
                <!-- <span v-if="tags.length==0">tags</span> -->
                <div
                  style="
                    min-width: calc(100% - 1.5rem);
                    max-width: calc(100% - 1.5rem);
                  "
                  class="wrapper"
                  ref="wrapper"
                >
                  <div v-if="ctags.length == 0" style="color: #ccc">
                    please choose
                  </div>
                  <div
                    v-for="(ctag, index3) in ctags"
                    :key="index3"
                    class="wrapper-content"
                    style="
                      background-color: #f7f8fa;
                      margin-right: 0.2rem;
                      margin-bottom: 0.2rem;
                    "
                  >
                    {{ ctag.name }}
                    <img
                      src="../../assets/imgs/close-tag.png"
                      style="width: 1rem; height: 1rem"
                      @click.stop="closectag(ctag.value)"
                    />
                  </div>
                </div>
                <div style="margin-left: 0.5rem">
                  <img
                    src="../../assets/imgs/user/add.svg"
                    style="width: 1rem; height: 1rem; cursor: pointer"
                  />
                </div>
              </div>
              <div style="top: 5.5rem" class="sel-box" v-show="cbox">
                <div
                  v-for="(item, index2) in ctagsdata"
                  :key="index2"
                  class="sel-box-list"
                  @click="changectags(item)"
                  v-show="
                    ctags.findIndex((key) => key.value == item.value) == -1
                  "
                >
                  <span style="flex: 1">{{ item.name }}</span>
                </div>
              </div>
            </div>

            <!-- 网址 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                Website
              </div>
              <div>
                <div style="position: relative" class="publish-input">
                  <input
                    type="text"
                    v-model="website"
                    style="
                      border: none;
                      background-color: transparent;
                      width: 100%;
                    "
                  />
                </div>
              </div>
            </div>

            <!-- 认证图片 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                Qualification picture
              </div>
              <div style="display: flex; flex-wrap: wrap" class="publish-input">
                <!-- <div v-for="(img, imgindex) in imglist" :key="imgindex" :style="{backgroundImage:'url('+img+')'}" style="background-position: center;background-size: contain;
										background-repeat: no-repeat;margin-right: 0.5rem;margin-bottom: 0.5rem;width: 5rem;height: 5rem;"></div> -->

                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div style="flex: 1; display: flex; align-items: center">
                    <div style="display: flex">
                      <form action="" enctype="multipart/form-data">
                        <input
                          ref="fileInput"
                          type="file"
                          multiple="multiple"
                          accept="image/*"
                          @change="getImg"
                          id="imgfile"
                        />
                      </form>
                      <div @click="clickimgFile()">
                        <img
                          src="../../assets/imgs/upload.svg"
                          style="
                            width: 2rem;
                            height: 2rem;
                            margin-right: 1rem;
                            cursor: pointer;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style="display: flex">
                  <div
                    v-for="(item, index) in img_list"
                    :key="index"
                    style="position: relative"
                  >
                    <div
                      @click="del(index)"
                      style="
                        position: absolute;
                        right: 0.5rem;
                        top: -0.5rem;
                        cursor: pointer;
                      "
                    >
                      <img
                        src="../../assets/imgs/close-gray.png"
                        style="width: 1rem; height: 1rem"
                      />
                    </div>
                    <img
                      :src="item"
                      style="width: 4rem; height: 4rem; margin-right: 1rem"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 详细介绍 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                style="
                  margin-bottom: 1rem;
                  display: flex;
                  align-items: center;
                  font-size: 1.2rem;
                  font-weight: bold;
                "
              >
                <span style="color: #fb2121">*</span>Brief introduction
              </div>
              <div>
                <!-- <textarea cols="30" rows="10" style="width: 100%;height: 10rem" class="publish-input"></textarea> -->
                <vue-editor
                  useCustomImageHandler
                  @image-added="handleImageAdded"
                  v-model="content2"
                  ref="editor"
                ></vue-editor>
              </div>
            </div>

            <!-- 提交 -->
            <div
              class="row"
              style="margin-bottom: 1rem; flex-direction: column"
            >
              <div
                class="btn-cyan-liner"
                @click="saveinfo()"
                style="
                  flex: 1;
                  width: 100%;
                  padding: 0.5rem 1.2rem;
                  align-items: center;
                  justify-content: center;
                  display: flex;
                  cursor: pointer;
                  font-weight: bold;
                "
              >
                Send
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "/src/components/header.vue";
import Footer from "/src/components/footer.vue";

import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      data: null,
      isMobile: false,

      coverimage: "",
      logo: "",

      // 行业
      tagbox: false,
      tag: "",
      tagdata: [],
      tagid: "",

      name: "",

      content1: "",
      content2: "",

      // 企业认证
      cbox: false,
      ctags: [],
      ctagsdata: [],

      img_list: [],
      website: "",

      // 1.申请 2.编辑
      type: 1,
      providerId: null,
    };
  },
  components: {
    Header,
    Footer,
    VueEditor,
  },
  methods: {
    tohome() {
      this.$router.push({ name: "home" });
    },
    changetag(obj) {
      this.tag = obj.en;
      this.tagid = obj.value;
      this.tagbox = false;
    },
    gettagdata() {
      this.request({
        method: "get",
        url: "/gci/index",
      })
        .then((res) => {
          this.tagdata = res.data.industries;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    getctagsdata() {
      this.request({
        method: "get",
        url: "/gci/certification",
      })
        .then((res) => {
          this.ctagsdata = res.data;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    closectag(v) {
      for (let i in this.ctags) {
        if (this.ctags[i].value == v) {
          this.ctags.splice(i, 1);
        }
      }
      this.cbox = 0;
    },
    changectags(obj) {
      this.ctags.push(obj);
    },

    clickimgFile() {
      // const input = document.querySelector('#file')
      // input.click()
      this.$refs.fileInput.dispatchEvent(new MouseEvent("click"));
    },
    clickcoverimage() {
      this.$refs.coverimage.dispatchEvent(new MouseEvent("click"));
    },
    clicklogo() {
      this.$refs.logo.dispatchEvent(new MouseEvent("click"));
    },
    getcoverimage(e) {
      var file = e.target.files; //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map((item) => {
        formdata.append("file", item); //将每一个文件图片都加进formdata
      });
      this.request.post("/upload", formdata).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.$bus.$emit("message", {
            type: 2,
            msg: "upload success",
          });
        }
        this.coverimage = res.data.url;
      });
    },
    getlogo(e) {
      var file = e.target.files; //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map((item) => {
        formdata.append("file", item); //将每一个文件图片都加进formdata
      });
      this.request.post("/upload", formdata).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.$bus.$emit("message", {
            type: 2,
            msg: "upload success",
          });
        }
        this.logo = res.data.url;
      });
    },
    getImg(e) {
      var file = e.target.files; //这个就是选中文件信息
      let formdata = new FormData();
      Array.from(e.target.files).map((item) => {
        console.log(item);
        formdata.append("file", item); //将每一个文件图片都加进formdata
      });
      this.request.post("/upload", formdata).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.$bus.$emit("message", {
            type: 2,
            msg: "upload success",
          });
        }
        this.img_list.push(res.data.url);
      });
    },
    del(index) {
      this.img_list.splice(index, 1);
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      console.info("useCustom");
      // 引入包内自带的formdata
      const formData = new FormData();
      // 将前端传入formdata中数据名为file的数据追加到formdata,与上篇文章的图片上传相同
      formData.append("file", file);
      // 使用我们上篇文章定义好的图片上传接口,将formdata数据传到后台,并接收返回的数据到res

      this.request.post("/upload", formData).then((res) => {
        console.log(res);
        if (res.status == 0) {
          this.$bus.$emit("message", {
            type: 2,
            msg: "upload success",
          });
          // 找到返回数据中的图片链接
          let url = res.data.url;
          console.info(url);
          // 用vue-editor包自带的插入方法:在光标所在位置,插入一张图片,图片的地址是url
          Editor.insertEmbed(cursorLocation, "image", url);
          // 刷新(重置)编辑器
          resetUploader();
        }
      });
    },
    saveinfo() {
      if (!this.coverimage) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "upload cover image",
        });
      } else if (!this.logo) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "upload logo",
        });
      } else if (!this.tagid) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "enter Industry",
        });
      } else if (!this.name) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "enter Service Providers name",
        });
      } else if (!this.content1) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "enter brief introduction",
        });
      }
      //   else if (this.ctags.length == 0) {
      //     this.$bus.$emit("message", {
      //       type: 1,
      //       msg: "enter Enterprise Certification",
      //     });
      //   }
      else if (!this.content2) {
        this.$bus.$emit("message", {
          type: 1,
          msg: "enter brief introduction",
        });
      } else {
        // 认证图片处理
        let credentials = "";
        for (let i in this.img_list) {
          credentials += this.img_list[i] + ",";
        }
        credentials = credentials.substring(0, credentials.length - 1);
        // 认证id处理(传后端)
        let cids = "";
        for (let i in this.ctags) {
          cids += this.ctags[i].value + ",";
        }
        cids = cids.substring(0, cids.length - 1);

        let params = {
          industryId: this.tagid,
          coverImage: this.coverimage,
          logo: this.logo,
          providerName: this.name,
          providerDescription: this.content1,
          credentials: credentials,
          cids: cids,
          website: this.website,
          profile: this.content2,
        };
        console.info(params);

        let url = "";
        if (this.type == 1) {
          url = "/gci/user/provider/apply";
        }
        if (this.type == 2) {
          url = "/gci/user/provider/" + this.providerId + "/edit";
        }
        this.request({
          method: "post",
          url: url,
          data: params,
        })
          .then((res) => {
            if (res.status == 0) {
              this.$bus.$emit("message", {
                type: 2,
                msg: "success",
              });
              this.$router.go(-1);
            } else {
              this.$bus.$emit("message", {
                type: 3,
                msg: res.msg,
              });
            }
          })
          .catch((error) => {
            console.error(error.response);
          });
      }
    },
    getuserinfo() {
      this.request({
        method: "get",
        url: "/gci/user/info",
      })
        .then((res) => {
          let provider = res.data.provider;
          if (provider) {
            this.type = 2;
            this.coverimage = provider.coverImage;
            this.logo = provider.logo;
            this.name = provider.providerName;
            this.website = provider.website;
            this.content1 = provider.providerDescription;
            this.content2 = provider.profile;
            this.img_list = provider.credentials;
            this.providerId = provider.id;

            // 行业id处理
            this.tagid = provider.industryId;
            this.tagdata.findIndex((key) => {
              if (key.value == this.tagid) {
                this.tag = key.en;
              }
            });

            // 认证id处理
            let cidlist = provider.cids.split(",");
            this.ctags = [];
            this.ctagsdata.findIndex((key) => {
              if (cidlist.includes(key.id.toString())) {
                this.ctags.push(key);
              }
            });
          }
          console.info("porvider", provider);
          this.$bus.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    handPaste() {
      return false;
    },
  },
  created() {
    this.$bus.$emit("loading", true);
  },
  mounted() {
    localStorage.getItem("isMobile") == "null"
      ? (this.isMobile = false)
      : (this.isMobile = true);
    Promise.all([this.gettagdata(), this.getctagsdata()]).then((res) => {
      /* 供应商编辑信息 */
      this.getuserinfo();
    });
    this.$refs.editor.quill.root.addEventListener("paste", (evt) => {
      if (
        evt.clipboardData &&
        evt.clipboardData.files &&
        evt.clipboardData.files.length
      ) {
        console.info("is file");
        evt.preventDefault();
        [].forEach.call(evt.clipboardData.files, (file) => {
          if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
            return;
          }
          var formData = new FormData();
          formData.append("uploadFile", file);
          this.request.post("/upload", formData).then((res) => {
            // 找到返回数据中的图片链接
            let url = res.data.url;
            const quill = this.$refs.editor.quill;
            var range = quill.getSelection();
            if (range) {
              // this.ruleForm.problemPics = this.ruleForm.problemPics + ',' + res.data
              const length = quill.getSelection().index;
              quill.insertEmbed(length, "image", url);
              quill.setSelection(length + 1);
              // eslint-disable-next-line no-unused-vars
              let fileType = null;
              if (file.raw && file.raw.type) {
                fileType = file.raw.type;
              } else {
                fileType = file.type;
              }
              this.uploadList = [];
              this.$refs.editor.quill.setSelection(range.index + 1);
            }
          });
        });
      } else {
        console.info("is text");
      }
      console.info(evt);
    });
    console.info(this.$refs.editor.quill);
  },
};
</script>

<style scoped lang="scss">
#imgfile {
  display: none;
}
.r-title {
  height: 3rem;
  font-size: 1.5rem;
  font-weight: bold;
  position: relative;
  .r-title-bg {
    width: 13rem;
    position: absolute;
    left: -0.5rem;
    top: -2rem;
  }
}

.publish-input {
  background-color: #fff;
  border: 1px solid #d1d1d1;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  border-radius: 0.2rem;
}

// 下拉
.sel-box {
  width: 100%;
  max-height: 20rem;
  position: absolute;
  background-color: #fff;
  border: 1px solid #000;
  left: 0;
  top: 2.5rem;
  overflow: scroll;
  z-index: 20;
  .sel-box-list {
    display: flex;
    padding: 0 1rem;
  }
}
.sel-box-list:hover {
  background-color: #31ffda;
}
.sel-box::-webkit-scrollbar {
  display: none;
}

.box-main {
  padding: 3rem;
}
@media (max-width: 767px) {
  .container {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .row {
    flex-direction: column;
  }
  .mw-100 {
    max-width: 100%;
    margin-bottom: 1rem;
  }
  .w-50 {
    width: 100% !important;
  }
  .box-main {
    padding: 2rem;
  }
}
@media (min-width: 767px) {
  .w-50 {
    width: 50%;
  }
}
</style>
